import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  EnumService,
  InstituicaoGestoraService,
  RepresentacaoInstituicaoGestoraService,
  TipoRepresentacaoInstituicaoGestoraService,
} from '../../../../../api/services';
import { ApiService } from '@core/providers/http';
import { AuthService } from '@core/service/auth.service';
import { dateRangeValidator } from '@core/validators/date-range.validator';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { parseDate } from '@core/validators/date-range.validator';
import { InputMaskModule } from 'primeng/inputmask';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-edit-representante',
  imports: [
    CommonModule,
    ButtonModule,
    ReactiveFormsModule,
    DialogModule,
    DatePickerModule,
    FileUploadModule,
    InputTextModule,
    Toast,
    Select,
    InputMaskModule,
  ],
  providers: [
    MessageService,
    ApiService,
    InstituicaoGestoraService,
    AuthService,
    EnumService,
    RepresentacaoInstituicaoGestoraService,
    DialogService,
    TipoRepresentacaoInstituicaoGestoraService,
  ],
  templateUrl: './edit-representante.component.html',
  styleUrl: './edit-representante.component.scss',
  standalone: true,
})
export class EditRepresentanteComponent implements OnInit {
  ref = inject(DynamicDialogRef);
  fb = inject(FormBuilder);
  config = inject(DynamicDialogConfig);
  messageService = inject(MessageService);
  dialogService = inject(DialogService);
  enumService = inject(EnumService);
  perfilRepresentante: any; // Recebe os dados do representante via Input

  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private instituicaoEnsinoService = inject(InstituicaoGestoraService);
  private representanteInstituicaoEnsinoService = inject(
    RepresentacaoInstituicaoGestoraService,
  );
  private router = inject(Router);
  tiposRepresentacao: any[] = [];
  nacionalidades: any[] = [
    {
      id: 1,
      designacao: 'Nacional',
    },
    {
      id: 2,
      designacao: 'Estrangeira',
    },
  ];
  representantes: any[] = [];
  representacaoForm!: FormGroup;
  isPatching = false;
  file: any;
  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL
  selectedFile: File | null = null;
  fotoPreviewMap: { [id: number]: string | ArrayBuffer | null } = {};

  editIndex: number | null = null;
  private tipoRepresentacaoService = inject(
    TipoRepresentacaoInstituicaoGestoraService,
  );
  isInternalInstitution: boolean = false;
  profileEducationalInstitution: any;
  isLoading: boolean = false;

  constructor() {
    this.representacaoForm = this.fb.group({
      nomeRepresentante: ['', Validators.required],
      telefoneRepresentante: ['', [Validators.required]],
      Bi: ['', Validators.required],
      emailRepresentante: ['', [Validators.required, Validators.email]],
      tipoRepresentacaoID: ['', Validators.required],
      NacionalidadeEnum: ['', Validators.required],
      ativo: [true],
      id: [null, Validators.required],
      usernameRepresentante: [''],
      instituicaoGestoraID: [this.instituicaoEnsinoID, Validators.required],
      Foto: [''], // novo campo
    });

    this.representacaoForm.controls?.[
      'NacionalidadeEnum'
    ].valueChanges.subscribe((value: any) => {
      if (this.isPatching) return;
      this.representacaoForm.patchValue({
        Bi: '',
      });
      this.onNacionalidadeChange(value);
    });

    this.representacaoForm.controls['Bi'].valueChanges.subscribe((value) => {
      if (this.isPatching) return;

      this.representacaoForm.patchValue({
        nomeRepresentante: '',
        telefoneRepresentante: '',
      });
    });
  }

  ngOnInit(): void {
    this.loadNacionalidade();
    if (this.config && this.config.data && this.config.data.representante) {
      this.perfilRepresentante = this.config.data.representante;
      this.patchRepresentante(this.perfilRepresentante);
    } else {
      console.error('perfilRepresentante não foi passado para o componente!');
    }

    this.loadTiposRepresentacao();
    this.loadInstitutionDetails();
  }

  get f() {
    return this.representacaoForm.controls;
  }

  get instituicaoEnsinoID(): number {
    return Number(this.route.snapshot.paramMap.get('id'));
  }

  loadInstitutionDetails(): void {
    this.instituicaoEnsinoService
      .show(this.instituicaoEnsinoID as any)
      .subscribe((data: any) => {
        this.profileEducationalInstitution = data;
      });
  }

  patchRepresentante(perfilEmpresagestora: any): void {
    this.isPatching = true;
    this.representacaoForm.patchValue({
      ...perfilEmpresagestora,
      id: +perfilEmpresagestora.id,
      NacionalidadeEnum: +perfilEmpresagestora.nacionalidadeEnum,
      Bi: perfilEmpresagestora.bi,
      nome: perfilEmpresagestora.nome,
      telefone: perfilEmpresagestora.telefone,
      emailRepresentante: perfilEmpresagestora.emailRepresentante,
      TipoRepresentacaoInstituicaoEnsinoID:
        +perfilEmpresagestora.tipoRepresentacaoInstituicaoEnsinoID,
      ativo: true,
      instituicaoEnsinoID: +perfilEmpresagestora.instituicaoEnsinoID,
      Foto: perfilEmpresagestora.Foto,
    });

    this.representacaoForm.patchValue({
      Bi: perfilEmpresagestora.bi,
    });
    this.representanteInstituicaoEnsinoService
      .getFotoRepresentacaoInstituicaoGestoraById(perfilEmpresagestora.id)
      .subscribe((response) => {
        if (!response) return;
        if (!response || !response.type.startsWith('image/')) {
          console.warn('Resposta não é imagem. A usar placeholder.');
          this.imagePreview = null;
          return;
        }
        const file = new File([response], 'representative-photo.jpg', {
          type: response.type,
        });
        this.selectedFile = file;

        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreview = reader.result as string;
        };
        reader.readAsDataURL(file);

        this.representacaoForm.patchValue({ Foto: file });
      });

    this.representacaoForm.patchValue({
      nome: perfilEmpresagestora.nome,
      telefone: perfilEmpresagestora.telefone,
    });

    ['telefone', 'emailRepresentante', 'NacionalidadeEnum'].forEach(
      (controlName) => {
        this.representacaoForm.get(controlName)?.enable();
      },
    );

    ['NacionalidadeEnum', 'Bi', 'nome'].forEach((controlName) =>
      this.representacaoForm.get(controlName)?.disable(),
    );

    this.isPatching = false;
  }

  onNacionalidadeChange(value: any) {
    this.isInternalInstitution = value === 1; // 'INTERNA' is selected
    if (this.isInternalInstitution) {
      ['nomeRepresentante'].forEach((control) => {
        this.representacaoForm.get(control)?.disable();
      });
    } else {
      [
        'nomeRepresentante',
        'telefoneRepresentante',
        'emailRepresentante',
      ].forEach((control) => {
        this.representacaoForm.get(control)?.enable();
      });
    }
  }

  searchDocumentNumber() {
    const biVal = this.f['Bi']?.value || this.f['bi']?.value;
    if (!biVal) return;

    this.authService.consultarBi(biVal as string).subscribe((result) => {
      const isSuccess =
        result?.retorno?.codigo == 200 ||
        result?.data?.code == 200 ||
        result?.data?.codigo == 200;
      if (isSuccess) {
        const personData = result.data?.data || result.data || {};
        const firstName = personData.first_name || personData.nome || '';
        const lastName = personData.last_name || personData.sobrenome || '';
        const nomeCompleto = `${firstName} ${lastName}`.trim();

        const patchValues: any = {};
        if (nomeCompleto) {
          patchValues.nomeRepresentante = nomeCompleto;
        }
        if (personData.numeroContacto || personData.telefone) {
          patchValues.telefoneRepresentante =
            personData.numeroContacto || personData.telefone;
        }
        if (personData.email) {
          patchValues.emailRepresentante = personData.email;
        }

        this.representacaoForm.patchValue(patchValues);

        this.representacaoForm.controls['emailRepresentante']?.enable();
        this.representacaoForm.controls['telefoneRepresentante']?.enable();
      }
    });
  }

  loadTiposRepresentacao() {
    this.tipoRepresentacaoService.list().subscribe((tiposRepresentacao) => {
      this.tiposRepresentacao = tiposRepresentacao.data;
    });
  }

  choose(event: any, callback: () => void) {
    callback();
  }

  onSelectedFiles(event: { currentFiles: any }) {
    this.file = event.currentFiles[0];

    //Adicionar validação de tamanho da imagem (ex: máx. 2MB)
    const maxSizeMB = 2;
    if (this.file.size > maxSizeMB * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Imagem muito grande',
        detail: `A imagem deve ter no máximo ${maxSizeMB}MB.`,
        life: 3000,
      });
      return;
    }

    const isImage = this.file.type.startsWith('image/');
    if (!isImage) {
      this.messageService.add({
        severity: 'error',
        summary: 'Formato inválido',
        detail: 'Apenas imagens são permitidas.',
        life: 3000,
      });
      return;
    }

    if (this.file) {
      this.selectedFile = this.file;
      this.representacaoForm.patchValue({ Foto: this.file });

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.file);
    }
  }

  onSubmit() {
    if (this.representacaoForm.valid) {
      if (this.representacaoForm.invalid) {
        this.representacaoForm.markAllAsTouched();
        this.messageService.add({
          severity: 'warn',
          summary: 'Atenção',
          detail: 'Por favor, preencha todos os campos obrigatórios.',
        });
        return;
      }
      if (this.representacaoForm.value) {
        const rawData = this.representacaoForm.getRawValue();
        const formData = new FormData();
        for (const key in rawData) {
          if (key !== 'Foto') {
            if (!rawData[key]) continue;
            formData.append(key, rawData[key]);
          }
        }

        formData.append(
          'UsernameRepresentante',
          !this.isInternalInstitution ? rawData.emailRepresentante : rawData.Bi,
        );

        if (rawData.Foto && this.selectedFile) {
          formData.append('foto', this.selectedFile);
        }

        this.ref.close(formData); // envia o FormData para o componente pai
      } else {
        this.representacaoForm.markAllAsTouched();
        if (!this.selectedFile) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: 'Por favor selecione uma imagem para o logotipo.',
          });
        }
      }
    }
  }

  loadNacionalidade() {
    this.enumService.getAllNacionalidadeEnum().subscribe((response) => {
      if (response?.data) {
        this.nacionalidades = Object.entries(response.data).map(
          ([key, value]) => ({
            id: Number(key),
            designacao: value,
          }),
        );
      }
    });
  }

  cancel() {
    if (this.ref) {
      this.ref.close(); // Fecha a modal
    } else {
      console.error('DynamicDialogRef não foi injetado corretamente!');
    }
  }
}
